import { createSelector } from 'reselect';

const getAgentNameById = (list, id) => {
  const agent = list.find(val => val.id === id);
  return (agent && (agent.realname || agent.nickname)) || '';
};

export const getHistoryConvs = createSelector([data => data, (data, agents) => agents], (data, agents) => {
  return data.map(val => {
    const { created_on, agent_id, id } = val;
    return {
      time: created_on,
      agent: getAgentNameById(agents, agent_id),
      convId: id
    };
  });
});
